import React, { useState, useEffect } from "react";
import "./Onboarding.scss";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Card, Table, Button, Tooltip, Badge } from "antd";
import API from "api/endpoints";
import Footer from "Common/Footer";
import { useNavigate } from "react-router-dom";
import axiosInstance from "api/axiosInstance";
import {
  JobApplicationStatusEnum,
  JobApplicationStatusLabel,
  JobApplicationStatusText,
} from "Constants/Enums/JobApplicantStatusEnum";

const Onboarding = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const handleOnboarding = (empId, employeeEmail) => {
    navigate(`/hiringOnboarding/${empId}`);
  };

  const columns = [
    { title: "Employee_ID", dataIndex: "employeeId", key: "employeeId" },
    {
      title: "Name",
      key: "name",
      render: (text, record) => `${record.firstName} ${record.lastName}`,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (email) => (
        <Tooltip title={email}>{email.length > 13 ? `${email.slice(0, 13)}...` : email}</Tooltip>
      ),
    },
    { title: "Gender", dataIndex: "gender", key: "gender" },
    { title: "Job", dataIndex: "forJobApply", key: "forJobApply" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => JobApplicationStatusLabel[status] || status,
    },
    {
      title: "Status Detail",
      dataIndex: "status",
      key: "statusDetail",
      render: (status) => <span style={{ color: "#888" }}>{JobApplicationStatusText[status]}</span>,
    },

    {
      title: "Onboard",
      key: "onboard",
      render: (text, record) => {
        const status = record.status;

        if (status === JobApplicationStatusEnum.OnboardingDone) {
          return <Badge color="green" text="Onboarding Completed" />;
        }

        if (status === JobApplicationStatusEnum.Hired) {
          return <Badge color="blue" text="Hired" />;
        }

        let buttonDisabled = true;
        let tooltipText = "Onboarding is not ready";

        if (status === JobApplicationStatusEnum.DocumentRecieved) {
          buttonDisabled = false;
          tooltipText = "Employee onboarding in progress";
        }

        return (
          <Tooltip title={tooltipText}>
            <Button
              type="link"
              disabled={buttonDisabled}
              onClick={() => handleOnboarding(record.employeeId, record.email)}
            >
              Onboarding
            </Button>
          </Tooltip>
        );
      },
    },
  ];

  return (
    <DashboardLayout>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <DashboardNavbar />
        <div className="body flex-grow-1 px-3">
          <Card title="Onboarding Checklist" className="card-professional">
            <div className="row">
              <Table
                className="custom-table"
                bordered
                columns={columns}
                dataSource={data}
                loading={loading}
              />
            </div>
          </Card>
          <Footer />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Onboarding;
